const initialValue = {
    gateway: null
};

export default function errorReducer(state = initialValue, action) {
    switch (action.type) {
        case "SET_DEBUG_GATEWAY":
            return {...state, gateway: action.payload};
        case "CHANGE_FARM":
        case "USER_LOGOUT_FULFILLED": {
            return initialValue;
        }
        default:
            return state
    }
}
